<template>
  <div id="company-profile">
    <h3 class="title">{{ this.$t("lang.About.chg") }}</h3>
    <img src="../../assets/images/about.png" alt="" />
    <div class="introduce">
      <p>
        {{ this.$t("lang.About.chgDetail1") }}
      </p>
      <p>
        {{ this.$t("lang.About.chgDetail2") }}
      </p>
    </div>
    <div class="company-culture">
      <vice-title>
        <h3>{{ this.$t("lang.About.companyCulture") }}</h3>
      </vice-title>
      <table>
        <tr>
          <td>{{ this.$t("lang.About.ourValue") }}</td>
          <td>{{ this.$t("lang.About.ourValueDetail") }}</td>
        </tr>
      </table>

      <table>
        <tr>
          <td>{{ this.$t("lang.About.ourMission") }}</td>
          <td>{{ this.$t("lang.About.ourMissionDetail") }}</td>
        </tr>
      </table>

      <table>
        <tr>
          <td>{{ this.$t("lang.About.ourWish") }}</td>
          <td>{{ this.$t("lang.About.ourWishDetail") }}</td>
        </tr>
      </table>

      <div class="Culture">
        <img src="../../assets/images/Culture.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
import PublicImg from "../PublicImg";
export default {
  name: "CompanyProfile",
  components: {
    ViceTitle
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#company-profile {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #ffffff;
  img {
    width: 100%;
  }
  .title {
    text-align: center;
    color: #363636;
    font-size: 22px;
    margin: 30px 0;
  }
  .introduce {
    margin: 10px auto;
    width: 75%;
    overflow: hidden;
    .desire {
      margin-top: 40px;
    }
    p {
      font-size: 18px;
      margin-top: 24px;
      color: #828282;
      line-height: 30px;
      text-indent: 2em;
    }
  }
  .company-culture {
    width: 75%;
    margin: 0 auto;
    color: #828282;
    font-size: 18px;
    table {
      line-height: 50px;
    }
  }
  .Culture {
    width: 100%;
    margin-top: 53px;
    img {
      width: 100%;
    }
  }
}
</style>
